import React from 'react'
import { Icon, GridRow , Grid, Container ,Menu, MenuItem, GridColumn , Popup } from 'semantic-ui-react'
import { Link } from 'react-router-dom';
import "./Footer.scss"






export default function footer() {

  const aviso = () => {
    
    window.history.go(-1);
  
  };
  
  const reload = () => {
      
  
    window.location.reload()
  };




  return (



<>
<GridColumn  className='fetfow'  >
<Popup
    content={"Regresar"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name='arrow alternate circle left' color='red' size='large' onClick={aviso} circular />}
  />      
 
 <Link to = "/Category">
 <Popup
    content={"Categorias"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "sitemap" color='#37fd12'   size='large' circular  />}
  />      
 
 </Link>
 <Link to = "/Followers" >
 <Popup
    content={"Siguiendo "}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "users" color='#1e5e35'   size='large' circular  />}
  />      
</Link>
<Link  to = "/info" > 

<Popup
    content={"Informacion"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "question circle outline" color='#1e5e35'   size='large' circular  />}
  />      

</Link>



<Popup
    content={"Recargar"}
    //on='click'
    //pinned
    hideOnScroll
    trigger={<Icon name= "redo" color='#1e5e35'   size='large' circular onClick={reload} />}
  />      







</GridColumn>

</>

  )
}
